module.exports = __webpack_public_path__ + "static/media/pie-chart.39137f79.png";